import { render, staticRenderFns } from "./ResourceSearchInput.vue?vue&type=template&id=6614b52c&scoped=true"
import script from "./ResourceSearchInput.vue?vue&type=script&lang=js"
export * from "./ResourceSearchInput.vue?vue&type=script&lang=js"
import style0 from "./ResourceSearchInput.vue?vue&type=style&index=0&id=6614b52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6614b52c",
  null
  
)

export default component.exports